import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.ProgramRobot;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "ProgramRobot.Phaser.IntroductionScene.1",
            "ProgramRobot.Phaser.IntroductionScene.2",
            "ProgramRobot.Phaser.IntroductionScene.3",
            "ProgramRobot.Phaser.IntroductionScene.4",
            "ProgramRobot.Phaser.IntroductionScene.5",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/ProgramRobotGame/scenes/GameIntro.ts